import { Component, Input, OnInit } from '@angular/core';
import { IJobTaskInfo } from '../../../interfaces/telephony/job-task-info';

@Component({
  selector: 'task-information-card',
  templateUrl: './task-information-card.component.html',
  styleUrls: ['./task-information-card.component.scss'],
})
export class TaskInformationCardComponent implements OnInit {
  constructor() {}

  @Input() task: IJobTaskInfo;
  @Input() isCustomerView: boolean;

  ngOnInit() {}
}
